import { SegmentedControl } from '@mantine/core';
import { useKey } from 'react-use';
import { dataObject, dataScene } from './EditorMode.data';
import { Wrapper } from './EditorMode.style';

export type EditorModeProps = {
  mode: string;
  onToggle: (mode: string) => void;
  children?: React.ReactNode;
  flavour?: 'object' | 'scene';
};

export function EditorMode(props: EditorModeProps) {
  const { mode, flavour = 'object' } = props;

  const data: any[] = flavour === 'object' ? dataObject : dataScene;

  const item = data.find((i) => i.value.toLowerCase() === mode) ?? data[0];
  const value = item.value;
  const color = item.color;

  function onChange(value: string) {
    props.onToggle(value.toLowerCase());
  }

  useKey(
    (ev) => ev.code === 'Digit1' && ev.altKey,
    () => props.onToggle(data[0].value.toLowerCase()),
    {},
    [mode]
  );

  useKey(
    (ev) => ev.code === 'Digit2' && ev.altKey,
    () => props.onToggle(data[1].value.toLowerCase()),
    {},
    [mode]
  );

  return (
    <Wrapper className='EditorMode-wrapper' data-testid='EditorMode-wrapper'>
      <SegmentedControl value={value} onChange={onChange} data={data} color={color} />
      {props.children}
    </Wrapper>
  );
}

export default EditorMode;
